import { type FC } from 'react';
import { useSelector } from 'react-redux';
import { type RootState } from '@editor2/reducers/root';
import { commitAuthorName } from '../styles';

interface Props {
	courseId: number;
}

const IncomingChangesAuthors: FC<Props> = (props) => {
	const { courseId } = props;

	const { commits } = useSelector((state: RootState) => state.courses[courseId]);

	const getUniqueAuthorsNames = (commits) => {
		const names = commits.map((commits) => commits.user_name);
		const namesSet = new Set(names);

		return Array.from(namesSet);
	};

	return (
		<>
			{commits?.length &&
				getUniqueAuthorsNames(commits).map((name: string) => (
					<span className={commitAuthorName} key={name}>
						{name}
					</span>
				))}
		</>
	);
};

export default IncomingChangesAuthors;
